module.exports = __webpack_public_path__ + "img/index-fhgl.b66a1a33.png";